/* eslint-disable @typescript-eslint/naming-convention */
import type { Locale } from '@lemonade-hq/lemonation';
import type { Tweet } from '../../components/TweetCard';
import type { TweetsProps } from '../../components/Tweets';
import { tweets as DE } from './de';
import { tweets as enDE } from './enDE';
import { tweets as enFR } from './enFR';
import { tweets as enNL } from './enNL';
import { tweets as FR } from './fr';
import { tweets as GB } from './gb';
import { tweets as NL } from './nl';
import { tweets as US } from './us';

export type TweetsLocale = Exclude<Locale, 'es-US'>;

const regionTweets: Record<TweetsLocale, Tweet[]> = {
  'en-US': US,
  'de-DE': DE,
  'nl-NL': NL,
  'fr-FR': FR,
  'en-GB': GB,
  'en-DE': enDE,
  'en-NL': enNL,
  'en-FR': enFR,
};

export const getTweets = (locale: TweetsLocale): TweetsProps['tweets'] => regionTweets[locale];
